export const countryCode: any = {
    "AFGHANISTAN": "AFG",
    "ÅLAND ISLANDS": "ALA",
    "ALBANIA": "ALB",
    "ALGERIA": "DZA",
    "AMERICAN SAMOA": "ASM",
    "ANDORRA": "AND",
    "ANGOLA": "AGO",
    "ANGUILLA": "AIA",
    "ANTARCTICA": "ATA",
    "ANTIGUA AND BARBUDA": "ATG",
    "ARGENTINA": "ARG",
    "ARMENIA": "ARM",
    "ARUBA": "ABW",
    "AUSTRALIA": "AUS",
    "AUSTRIA": "AUT",
    "AZERBAIJAN": "AZE",
    "BAHAMAS": "BHS",
    "BAHRAIN": "BHR",
    "BANGLADESH": "BGD",
    "BARBADOS": "BRB",
    "BELARUS": "BLR",
    "BELGIUM": "BEL",
    "BELIZE": "BLZ",
    "BENIN": "BEN",
    "BERMUDA": "BMU",
    "BHUTAN": "BTN",
    "BOLIVIA": "BOL",
    "BONAIRE, SINT EUSTATIUS AND SABA": "BES",
    "BOSNIA AND HERZEGOVINA": "BIH",
    "BOTSWANA": "BWA",
    "BOUVET ISLAND": "BVT",
    "BRAZIL": "BRA",
    "BRITISH INDIAN OCEAN TERRITORY": "IOT",
    "BRUNEI DARUSSALAM": "BRN",
    "BULGARIA": "BGR",
    "BURKINA FASO": "BFA",
    "BURUNDI": "BDI",
    "CAMBODIA": "KHM",
    "CAMEROON": "CMR",
    "CANADA": "CAN",
    "CAPE VERDE": "CPV",
    "CAYMAN ISLANDS": "CYM",
    "CENTRAL AFRICAN REPUBLIC": "CAF",
    "CHAD": "TCD",
    "CHILE": "CHL",
    "CHINA": "CHN",
    "CHRISTMAS ISLAND": "CXR",
    "COCOS (KEELING) ISLANDS": "CCK",
    "COLOMBIA": "COL",
    "COMOROS": "COM",
    "CONGO": "COG",
    "CONGO, THE DEMOCRATIC REPUBLIC OF THE": "COD",
    "COOK ISLANDS": "COK",
    "COSTA RICA": "CRI",
    "CÔTE D'IVOIRE(IVORY COAST)": "CIV",
    "CROATIA": "HRV",
    "CUBA": "CUB",
    "CURAÇAO": "CUW",
    "CYPRUS": "CYP",
    "CZECH REPUBLIC": "CZE",
    "DENMARK": "DNK",
    "DJIBOUTI": "DJI",
    "DOMINICA": "DMA",
    "DOMINICAN REPUBLIC": "DOM",
    "ECUADOR": "ECU",
    "EGYPT": "EGY",
    "EL SALVADOR": "SLV",
    "EQUATORIAL GUINEA": "GNQ",
    "ERITREA": "ERI",
    "ESTONIA": "EST",
    "ETHIOPIA": "ETH",
    "FALKLAND ISLANDS (MALVINAS)": "FLK",
    "FAROE ISLANDS": "FRO",
    "FIJI": "FJI",
    "FINLAND": "FIN",
    "FRANCE": "FRA",
    "FRENCH GUIANA": "GUF",
    "FRENCH POLYNESIA": "PYF",
    "FRENCH SOUTHERN TERRITORIES": "ATF",
    "GABON": "GAB",
    "GAMBIA": "GMB",
    "GEORGIA": "GEO",
    "GERMANY": "DEU",
    "GHANA": "GHA",
    "GIBRALTAR": "GIB",
    "GREAT BRITAIN": "GBR",
    "GREECE": "GRC",
    "GREENLAND": "GRL",
    "GRENADA": "GRD",
    "GUADELOUPE": "GLP",
    "GUAM": "GUM",
    "GUATEMALA": "GTM",
    "GUERNSEY": "GGY",
    "GUINEA": "GIN",
    "GUINEA-BISSAU": "GNB",
    "GUYANA": "GUY",
    "HAITI": "HTI",
    "HEARD ISLAND AND MCDONALD ISLANDS": "HMD",
    "HOLY SEE (VATICAN CITY STATE)": "VAT",
    "HONDURAS": "HND",
    "HONG KONG": "HKG",
    "HUNGARY": "HUN",
    "ICELAND": "ISL",
    "INDIA": "IND",
    "INDONESIA": "IDN",
    "IRAN, ISLAMIC REPUBLIC OF": "IRN",
    "IRAQ": "IRQ",
    "IRELAND": "IRL",
    "ISLE OF MAN": "IMN",
    "ISRAEL": "ISR",
    "ITALY": "ITA",
    "JAMAICA": "JAM",
    "JAPAN": "JPN",
    "JERSEY": "JEY",
    "JORDAN": "JOR",
    "KAZAKHSTAN": "KAZ",
    "KENYA": "KEN",
    "KIRIBATI": "KIR",
    "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF": "PRK",
    "KOSOVO": "",
    "KOREA, REPUBLIC OF": "KOR",
    "KUWAIT": "KWT",
    "KYRGYZSTAN": "KGZ",
    "LAO PEOPLE'S DEMOCRATIC REPUBLIC": "LAO",
    "LATVIA": "LVA",
    "LEBANON": "LBN",
    "LESOTHO": "LSO",
    "LIBERIA": "LBR",
    "LIBYAN ARAB JAMAHIRIYA": "LBY",
    "LIECHTENSTEIN": "LIE",
    "LITHUANIA": "LTU",
    "LUXEMBOURG": "LUX",
    "MACAO": "MAC",
    "MADAGASCAR": "MDG",
    "MALAWI": "MWI",
    "MALAYSIA": "MYS",
    "MALDIVES": "MDV",
    "MALI": "MLI",
    "MALTA": "MLT",
    "MARSHALL ISLANDS": "MHL",
    "MARTINIQUE": "MTQ",
    "MAURITANIA": "MRT",
    "MAURITIUS": "MUS",
    "MAYOTTE": "MYT",
    "MEXICO": "MEX",
    "MICRONESIA, FEDERATED STATES OF": "FSM",
    "MOLDOVA": "MDA",
    "MONACO": "MCO",
    "MONGOLIA": "MNG",
    "MONTENEGRO": "MNE",
    "MONTSERRAT": "MSR",
    "MOROCCO": "MAR",
    "MOZAMBIQUE": "MOZ",
    "MYANMAR": "MMR",
    "NAMIBIA": "NAM",
    "NAURU": "NRU",
    "NEPAL": "NPL",
    "NETHERLANDS": "NLD",
    "NEW CALEDONIA": "NCL",
    "NEW ZEALAND": "NZL",
    "NICARAGUA": "NIC",
    "NIGER": "NER",
    "NIGERIA": "NGA",
    "NIUE": "NIU",
    "NORFOLK ISLAND": "NFK",
    "NORTHERN IRELAND": "GBR",
    "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF": "MKD",
    "NORTHERN MARIANA ISLANDS": "MNP",
    "NORWAY": "NOR",
    "OMAN": "OMN",
    "PAKISTAN": "PAK",
    "PALAU": "PLW",
    "PALESTINIAN TERRITORY, OCCUPIED": "PSE",
    "PANAMA": "PAN",
    "PAPUA NEW GUINEA": "PNG",
    "PARAGUAY": "PRY",
    "PERU": "PER",
    "PHILIPPINES": "PHL",
    "PITCAIRN": "PCN",
    "POLAND": "POL",
    "PORTUGAL": "PRT",
    "PUERTO RICO": "PRI",
    "QATAR": "QAT",
    "RÉUNION": "REU",
    "ROMANIA": "ROU",
    "RUSSIAN FEDERATION": "RUS",
    "RWANDA": "RWA",
    "SAINT BARTHÉLEMY": "BLM",
    "SAINT HELENA": "SHN",
    "SAINT KITTS AND NEVIS": "KNA",
    "SAINT LUCIA": "LCA",
    "SAINT MARTIN": "MAF,SXM",
    "SAINT PIERRE AND MIQUELON": "SPM",
    "SAINT VINCENT AND THE GRENADINES": "VCT",
    "SAMOA": "WSM",
    "SAN MARINO": "SMR",
    "SAO TOME AND PRINCIPE": "STP",
    "SAUDI ARABIA": "SAU",
    "SENEGAL": "SEN",
    "SERBIA": "SRB",
    "SEYCHELLES": "SYC",
    "SIERRA LEONE": "SLE",
    "SINGAPORE": "SGP",
    "SLOVAKIA": "SVK",
    "SLOVENIA": "SVN",
    "SOLOMON ISLANDS": "SLB",
    "SOMALIA": "SOM",
    "SOUTH AFRICA": "ZAF",
    "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": "SGS",
    "SOUTH SUDAN": "SSD",
    "SPAIN": "ESP",
    "SRI LANKA": "LKA",
    "SUDAN": "SDN",
    "SURINAME": "SUR",
    "SVALBARD AND JAN MAYEN": "SJM",
    "SWAZILAND": "SWZ",
    "SWEDEN": "SWE",
    "SWITZERLAND": "CHE",
    "SYRIAN ARAB REPUBLIC": "SYR",
    "TAIWAN, R.O.C.": "TWN",
    "TAJIKISTAN": "TJK",
    "TANZANIA, UNITED REPUBLIC OF": "TZA",
    "THAILAND": "THA",
    "TIMOR-LESTE": "TLS",
    "TOGO": "TGO",
    "TOKELAU": "TKL",
    "TONGA": "TON",
    "TRINIDAD AND TOBAGO": "TTO",
    "TUNISIA": "TUN",
    "TURKEY": "TUR",
    "TURKMENISTAN": "TKM",
    "TURKS AND CAICOS ISLANDS": "TCA",
    "TUVALU": "TUV",
    "UGANDA": "UGA",
    "UKRAINE": "UKR",
    "UNITED ARAB EMIRATES": "ARE",
    "UNITED KINGDOM": "GBR",
    "UNITED STATES": "USA",
    "UNITED STATES MINOR OUTLYING ISLANDS": "UMI",
    "URUGUAY": "URY",
    "UZBEKISTAN": "UZB",
    "VANUATU": "VUT",
    "VENEZUELA": "VEN",
    "VIET NAM": "VNM",
    "VIRGIN ISLANDS, BRITISH": "VGB",
    "VIRGIN ISLANDS, U.S.": "VIR",
    "WALLIS AND FUTUNA": "WLF",
    "WESTERN SAHARA": "ESH",
    "YEMEN": "YEM",
    "ZAMBIA": "ZMB",
    "ZIMBABWE": "ZWE",
  };